// extracted by mini-css-extract-plugin
export default {"main":"Sidebar_main__bzCMF","linksBut":"Sidebar_linksBut__AvawK","logout":"Sidebar_logout__NfdNN","divider":"Sidebar_divider__UCj6Q","active":"Sidebar_active__aXoCe"};